class CookieBanner extends ModalElement {
  constructor() {
    super();

    if (!theme.config.isTouch || Shopify.designMode) {
      this.init();
    }
    else {
      new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
    }
  }

  get testMode() {
    return this.getAttribute('data-test-mode') === 'true';
  }

  get delay() {
    return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
  }

  get storageKey() {
    return 'theme:cookie-consent';
  }

  get storedConsent() {
    try {
      const value = window.localStorage.getItem(this.storageKey);
      return value === 'accepted' || value === 'declined' ? value : null;
    }
    catch (e) {
      return null;
    }
  }

  set storedConsent(value) {
    try {
      window.localStorage.setItem(this.storageKey, value);
    }
    catch (e) {
      console.warn('Cookie banner: unable to remember the visitor choice locally.', e);
    }
  }

  get acceptButton() {
    return this.querySelector('button[name="accept"]');
  }

  get declineButton() {
    return this.querySelector('button[name="decline"]');
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    if (this.testMode) {
      this.load(this.delay);
      return;
    }

    window.Shopify.loadFeatures([{
      name: 'consent-tracking-api',
      version: '0.1',
      onLoad: this.onConsentLibraryLoaded.bind(this)
    }]);
  }

  load(delay) {
    if (Shopify.designMode) return;

    setTimeout(() => this.show(), delay * 1000);

    if (this.acceptButton) this.acceptButton.addEventListener('click', this.acceptPolicy.bind(this));
    if (this.declineButton) this.declineButton.addEventListener('click', this.declinePolicy.bind(this));
  }

  acceptPolicy() {
    this.hide();
    this.storedConsent = 'accepted';
    this.setConsent(true);
  }

  declinePolicy() {
    this.hide();
    this.storedConsent = 'declined';
    this.setConsent(false);
  }

  setConsent(accepted) {
    const customerPrivacy = window.Shopify.customerPrivacy;

    if (!customerPrivacy) {
      console.warn('Cookie banner: consent tracking API unavailable, the choice was only stored locally.');
      return;
    }

    try {
      customerPrivacy.setTrackingConsent({
        analytics: accepted,
        marketing: accepted,
        preferences: accepted,
        sale_of_data: accepted
      }, (response) => {
        if (response?.error) console.warn('Cookie banner: Shopify refused to store the consent.', response.error);
      });
    }
    catch (e) {
      console.warn('Cookie banner: storing the consent with Shopify failed.', e);
    }
  }

  onConsentLibraryLoaded(error) {
    if (error) {
      console.warn('Cookie banner: consent tracking API failed to load.', error);
      return;
    }

    const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
    const storedConsent = this.storedConsent;

    if (storedConsent) {
      if (userTrackingConsent === 'no_interaction') this.setConsent(storedConsent === 'accepted');
      return;
    }

    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();

    if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
      this.load(this.delay);
    }
  }

  afterHide() {
    super.afterHide();
    document.body.classList.remove('has-cookie-banner');
  }
  afterShow() {
    super.afterShow();
    document.body.classList.add('has-cookie-banner');
  }
}
customElements.define('cookie-banner', CookieBanner);
